import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/style/index.scss";
import {
  Popover,
  Slider,
  Input,
  Select,
  Option,
  OptionGroup,
  ColorPicker,
  Loading,
} from "element-ui";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faUndo,
  faTrash,
  faCheck,
  faRedo,
  faMousePointer,
  faPencilAlt,
  faEraser,
  faImage,
  faFont,
  faSave,
  faUpload,
  faShareSquare,
  faAngleLeft,
  faAngleRight,
  faSortDown,
  faExpandArrowsAlt,
  faLock,
  faLockOpen,
  faInfoCircle,
  faGlobe,
  faStickyNote,
  faHandPaper,
  faPaperPlane,
  faPlus,
  faPlay,
  faPause,
  faVolumeUp,
  faVolumeDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSquare,
  faCircle,
  faFile,
  faFileAlt,
  faPlusSquare,
} from "@fortawesome/free-regular-svg-icons";
/* add icons to the library */
library.add(
  faUndo,
  faTrash,
  faCheck,
  faRedo,
  faMousePointer,
  faPencilAlt,
  faEraser,
  faImage,
  faFont,
  faSave,
  faUpload,
  faShareSquare,
  faAngleLeft,
  faAngleRight,
  faSortDown,
  faExpandArrowsAlt,
  faSquare,
  faCircle,
  faFile,
  faFileAlt,
  faPlusSquare,
  faLock,
  faLockOpen,
  faInfoCircle,
  faGlobe,
  faStickyNote,
  faHandPaper,
  faPaperPlane,
  faPlay,
  faPause,
  faVolumeUp,
  faVolumeDown
);
import jquery from "./plugins/jquery";
import jqueryui from "./plugins/jquery-ui";
// import axios from './plugins/axios'
import axios from "axios";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import jQueryUIPlugin from "jquery-ui-touch-punch";

Vue.use(jquery);
Vue.use(jqueryui);
// Vue.use(axios)
Vue.use(Popover);
Vue.use(Slider);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(ColorPicker);
Vue.use(Loading);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});
Vue.use(jQueryUIPlugin);

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_URL;

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

// 路由守衛
router.beforeEach(async (to, from, next) => {
  // 設置頁面title
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "New TP";
  }
  const whiteList = ["/"];
  if (whiteList.includes(to.path)) {
    next();
    return;
  }

  const key = sessionStorage.getItem("key");
  if (!key) {
    next("/");
    return;
  }

  if (store.state.classRoomId) {
    // Vuex 有有效的教室 ID，正常進入
    next();
  } else if (from.path === "/" && from.query && from.query.key) {
    // 從帶 key 的首頁（加入流程）跳轉過來但 classRoomId 未設置：
    // 表示加入過程中 Agora/API 失敗，home 組件會顯示錯誤狀態。
    // 取消導航（next(false)）讓首頁錯誤畫面顯示，
    // 避免重定向回 /?key=... 觸發死循環導致卡在載入中。
    next(false);
  } else {
    // 其他情況（直接訪問、刷新頁面）→ 重新走認證流程
    next(`/?key=${encodeURIComponent(key)}`);
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
